import { ITableCol } from "@data/interfaces/itable.interface";
import { ICronExpressionOption } from "../interfaces/wallet-config.interface";

export const REPORT_STATUS_ENUM = {
  'pending': 'Procesando',
  'success': 'Exitoso',
  'failed': 'Fallido'
};

export const REPORT_STATUS_COLOR_ENUM = {
  'pending': 'warning',
  'success': 'success',
  'failed': 'danger'
};

export const REPORT_STATUS_OPTIONS = [
  { label: 'Procesando', value: 'pending' },
  { label: 'Exitoso', value: 'success' },
  { label: 'Fallido', value: 'failed' }
];

export const WALLET_CONFIG_COLUMNS: ITableCol[] = [
  { type: 'text', field: 'type', header: 'Tipo', showFilter: true },
  { type: 'date', field: 'cutoffDate', header: 'Fecha de Corte', showFilter: true, dataType: 'date' },
  { type: 'date', field: 'generationDate', header: 'Fecha de Generación', showFilter: true, dataType: 'date' },
  { type: 'text', field: 'executedBy.names', header: 'Generado por', showFilter: true },
  { type: 'number', field: 'recipients.length', header: 'Emails enviados', showFilter: false },
  { type: 'number', field: 'recordCount', header: 'Registros', showFilter: false },
  { type: 'text', field: 'durationMs', header: 'Tiempo (ms)', showFilter: false },
  { type: 'enum', field: 'status', header: 'Estado', showFilter: true, dataType: 'enum', enum: REPORT_STATUS_ENUM, enumColor: REPORT_STATUS_COLOR_ENUM, options: REPORT_STATUS_OPTIONS },
];

// Actualizar acciones de la tabla principal para incluir botón de descarga adicional
export const WALLET_CONFIG_ACTIONS = [
  { icon: 'fa-regular fa-eye', action: 'VIEW', title: '', color: 'primary', permission: ['wallet-config', 'view'] as [string, string] },
  { icon: 'fa-solid fa-download', action: 'DOWNLOAD', title: '', color: 'success', permission: ['wallet-config', 'view'] as [string, string], rule: { field: 'status', value: 'success', type: 'equals' } }
];

// Nuevas constantes para configuraciones de corte
export const CUTOFF_CONFIG_STATUS_ENUM = {
  'active': 'Activo',
  'inactive': 'Inactivo'
};

export const CUTOFF_CONFIG_STATUS_COLOR_ENUM = {
  'active': 'success',
  'inactive': 'secondary'
};

export const CUTOFF_CONFIG_STATUS_OPTIONS = [
  { label: 'Activo', value: 'active' },
  { label: 'Inactivo', value: 'inactive' }
];

// Acciones para el modal de configuraciones
export const CUTOFF_CONFIG_ACTIONS = [
  { icon: 'fa-solid fa-edit', action: 'EDIT', title: 'Editar configuración', color: 'primary', permission: 'update' },
  { icon: 'fa-solid fa-trash', action: 'DELETE', title: 'Eliminar configuración', color: 'danger', permission: 'delete', rule: { field: 'isPrimary', value: false, type: 'equals' } },
  { icon: 'fa-solid fa-toggle-on', action: 'TOGGLE', title: 'Activar/Desactivar', color: 'warning', permission: 'update' }
];

// Expresiones cron comunes predefinidas
export const COMMON_CRON_EXPRESSIONS: ICronExpressionOption[] = [
  { 
    label: 'Diario a las 9:00 AM', 
    value: '0 9 * * *',
    description: 'Se ejecuta todos los días a las 9:00 de la mañana'
  },
  { 
    label: 'Primer día del mes a las 9:00 AM', 
    value: '0 9 1 * *',
    description: 'Se ejecuta el primer día de cada mes a las 9:00 AM'
  },
  { 
    label: 'Último día del mes a las 4:57 PM', 
    value: '57 16 L * *',
    description: 'Se ejecuta el último día del mes a las 4:57 PM'
  },
  { 
    label: 'Lunes a las 8:00 AM', 
    value: '0 8 * * 1',
    description: 'Se ejecuta todos los lunes a las 8:00 AM'
  },
  { 
    label: 'Viernes a las 5:00 PM', 
    value: '0 17 * * 5',
    description: 'Se ejecuta todos los viernes a las 5:00 PM'
  }
];

// Validaciones para formularios de configuración
export const CUTOFF_CONFIG_VALIDATION_RULES = {
  name: {
    required: true,
    maxLength: 100,
    minLength: 3
  },
  cronExpression: {
    required: true,
    pattern: /^(\*|[0-5]?\d)\s+(\*|[01]?\d|2[0-3])\s+(\*|[012]?\d|3[01]|L)\s+(\*|[0-9]|1[0-2])\s+(\*|[0-6])$/
  },
  recipients: {
    required: true,
    minItems: 1,
    maxItems: 10
  },
  description: {
    maxLength: 500
  }
};

// Mensajes de error para configuraciones
export const CUTOFF_CONFIG_ERROR_MESSAGES = {
  'ConflictException': 'Ya existe una configuración con este nombre',
  'BadRequestException': 'Datos inválidos. Verifique los campos marcados',
  'NotFoundException': 'Configuración no encontrada',
  'CRON_INVALID': 'Expresión cron inválida. Use formato: minuto hora día mes día-semana',
  'EMAIL_INVALID': 'Uno o más emails no tienen formato válido',
  'PRIMARY_EXISTS': 'Solo puede existir una configuración principal',
  'CANNOT_DELETE_PRIMARY': 'No se puede eliminar la configuración principal',
  'NAME_REQUIRED': 'El nombre de la configuración es obligatorio',
  'NAME_TOO_SHORT': 'El nombre debe tener al menos 3 caracteres',
  'NAME_TOO_LONG': 'El nombre no puede exceder 100 caracteres',
  'RECIPIENTS_REQUIRED': 'Debe especificar al menos un destinatario',
  'RECIPIENTS_LIMIT': 'No puede agregar más de 10 destinatarios',
  'DESCRIPTION_TOO_LONG': 'La descripción no puede exceder 500 caracteres'
};

// Configuraciones por defecto
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_EMAIL_RECIPIENTS = 10;
export const SUPPORTED_FILE_FORMATS = ['CSV'];
export const MAX_PROCESSING_TIME_MINUTES = 30;